<ng-template aside-content></ng-template>
